export const STEP_PHASE_MAP =

{
    "home": "none",
    "group-naming": "phase_01",
    "group-sizing": "phase_01",
    "members-naming": "phase_01",
    "roles-view": "phase_01",
    "advice-role-helper": "phase_01",
    "aside-role-reminder": "phase_01",
    "aside-role-details": "phase_01",
    "framing-init": "phase_01",
    "framing-split": "phase_01",
    "advice-tools-helper": "phase_01",
    "how-to-prompt": "phase_01",
    "framing-start-countdown": "phase_01",
    "framing-stop-countdown": "phase_01",
    "framing-group-answers": "phase_01",
    "does-the-tester-agree": "phase_01",
    "manager-get-first-mission": "phase_01",
    "lets-see-video": "phase_01",
    "choose-sdg-theme": "phase_01",
    "sdg-group-split": "phase_01",
    "sdg-start-countdown": "phase_01",
    "sdg-stop-countdown": "phase_01",
    "sdg-top-group-answers": "phase_01",
    "sdg-bottom-group-answers": "phase_01",
    "sdg-ending": "phase_01",
    "problem-step-init": "phase_01",
    "problem-countdown": "phase_01",
    "problem-have-problematic": "phase_01",
    "problem-ask-problematic": "phase_01",
    "problem-dashboard-intro": "phase_01",
    "problem-dashboard-intro-closure": "phase_01",
    "problem-phase-ending": "phase_01",
    "solution-step-init": "phase_02",
    "solution-chosen-problematic": "phase_02",
    "solution-propose-ideas": "phase_02",
    "solution-idea-brainstorming": "phase_02",
    "solution-ideas-list": "phase_02",
    "solution-sort-ideas": "phase_02",
    "solution-methodologies": "phase_02",
    "solution-talk-about-it": "phase_02",
    "solution-pitch-problematic": "phase_02",
    "solution-others-listen": "phase_02",
    "solution-representatives-passed": "phase_02",
    "solution-how-wow": "phase_02",
    "video-methodologie-1": "phase_02",
    "solution-sorting-matrix": "phase_02",
    "solution-best-ideas": "phase_02",
    "solution-choose-final-idea": "phase_02",
    "solution-final-idea-review": "phase_02",
    "solution-test-idea-intro": "phase_02",
    "solution-other-method": "phase_02",
    "video-methodologie-2": "phase_02",
    "go-to-canvas-phase-02": "phase_02",
    "aside-odd-canvas": "phase_02",
    "odd-canvas-phase02": "phase_02",
    "canvas-complete": "phase_02",
    "new-manager-fill-ia-log": "phase_02",
    "check-dashboard": "phase_02",
    "start-phase-03": "phase_03",
    "phase-03-description": "phase_03",
    "choice-of-deliverable-format": "phase_03",
    "phase-03-countdown": "phase_03",
    "aside-deliverable-post": "phase_03",
    "phase-03-deliverable": "phase_03",
    "phase-03-ending": "phase_03",
    "new-manager-fill-ia-log-again": "phase_03",
    "phase-04-intro": "phase_04",
    "phase-04-wording": "phase_04",
    "phase-04-group-selection": "phase_04",
    "phase-04-group-rating": "phase_04",
    "phase-04-ending": "phase_04",
    "phase-04-is-done": "phase_04"
} as const;